import { render, staticRenderFns } from "./QuotationLayout.vue?vue&type=template&id=c385ddf2"
import script from "./QuotationLayout.vue?vue&type=script&lang=js"
export * from "./QuotationLayout.vue?vue&type=script&lang=js"
import style0 from "./QuotationLayout.vue?vue&type=style&index=0&id=c385ddf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports